'use client';

import { getAbbreviatedNumber, getCsvFormattedNumber } from '@/shared/utils/number';
import React, { useEffect, useState } from 'react';

interface NumberCountdownProps {
  prefix?: string;
  endNumber: number;
  duration?: number;
  useShortNumbers?: boolean;
  useCsvNumbers?: boolean;
}

const NumberCountdown: React.FC<NumberCountdownProps> = ({
  prefix,
  endNumber,
  useShortNumbers,
  useCsvNumbers,
  duration = 400,
}) => {
  const [count, setCount] = useState<number>(0);

  useEffect(() => {
    let start: number | null = null;
    const step = (timestamp: number) => {
      if (start === null) start = timestamp;
      const progress = timestamp - start;
      const increment = Math.min(Math.ceil((progress / duration) * endNumber), endNumber);
      setCount(increment);

      if (progress < duration) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }, [endNumber, duration]);

  return (
    <div>
      {prefix}
      {useShortNumbers && getAbbreviatedNumber(count)}
      {useCsvNumbers && getCsvFormattedNumber(count)}
      {!useShortNumbers && !useCsvNumbers && count.toFixed(2)}
    </div>
  );
};

export default NumberCountdown;
